/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Navigate to product page when clicking a hover slide image
  document.addEventListener('click', function(e) {
    const slide = e.target.closest('.product-item__bg__slide');
    if (!slide) return;

    // Ignore clicks on buttons (prev/next arrows) or links
    if (e.target.closest('button, a')) return;

    const gridItem = slide.closest('[data-grid-item]');
    if (!gridItem) return;

    const url = gridItem.dataset.url;
    if (!url) return;

    window.location.href = url;
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
